export const STORE_FAVORITES_PROJECT = "STORE_FAVORITES_PROJECT";
export const STORE_FAVORITES_DASHBOARD = "STORE_FAVORITES_DASHBOARD";
